window.app = window.app || {};

window.app.resourcesList = {
  el: {
    section: document.querySelector('.mt-resources-cards:not(.initialized)'),
    sectionHeader: document.querySelector('.mt-resources-cards:not(.initialized) .mt-resources-cards__heading'),
    carousels: document.querySelectorAll('.mt-resources-cards:not(.initialized) .mt-resources-cards__carousel'),
    cardsLinks: document.querySelectorAll('.mt-resources-cards:not(.initialized) .mt-resource-card__title, .mt-resources-cards:not(.initialized) .mt-resource-card__btn-inner'),
    paginationBtns: document.querySelectorAll('.mt-resources-cards:not(.initialized) .mt-resources-cards__pagination-btn')
  },
  breakpoint: 'mobile',

  init: function() {
    const _this = this;
    const sliderConfig = { 
        slidesPerView: 1.1, 
        spaceBetween: 8,
        centeredSlides: true,
        pagination: {
            el: '.mt-resources-cards__carousel .swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.mt-resources-cards__arrow--next',
            prevEl: '.mt-resources-cards__arrow--prev',
        },
        breakpoints: {
            650: {
                slidesPerView: 1.2,
                centeredSlides: true
            },
            768: {
                slidesPerView: 1.5,
                centeredSlides: true
            },
            992: {
                centeredSlides: false,
                slidesPerView: 4,
                spaceBetween: 16
            }
        }
    };

    _this.breakpoint = (window.innerWidth >= 992) ? 'desktop' : 'mobile';
    _this.el.carousels.forEach(carousel => {
        const slider = carousel.querySelector('.swiper:not(.swiper-initialized)');
        if (_this.breakpoint === 'mobile' || (carousel.dataset.desktopCarousel === 'true' && _this.breakpoint === 'desktop')) {
            slider ? new Swiper(slider, sliderConfig) : null;
        }
    });
    window.addEventListener('resize', () => {
        const newBreakpoint = (window.innerWidth >= 992) ? 'desktop' : 'mobile';

        if (newBreakpoint !== _this.breakpoint) {
            const mobileOnlySliders = [..._this.el.carousels].filter(c => c.dataset.desktopCarousel === 'false');
            mobileOnlySliders.forEach(el => {
                const slider = el.querySelector('.swiper');
                (newBreakpoint === 'mobile') ? new Swiper(slider, sliderConfig) : slider?.swiper?.destroy();
            });
            _this.breakpoint = newBreakpoint;
        }
    });

    // Cards
    _this.el.cardsLinks.forEach(link => {
        link.addEventListener('click', () => {
            const articleTitle = link.closest('.mt-resource-card').querySelector('.mt-resource-card__title');
            articleTitle && app.dl.customClick(articleTitle.dataset.title, { location: _this.el.section.dataset.dlLocation });

            // Update URL with video
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('video', link.closest('.mt-resource-card').dataset.handle);
            window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
        });
    });

    // Desktop pagination (Load more)
    _this.el.paginationBtns.forEach(paginationBtn => {
        const carousel = paginationBtn.closest('.mt-resources-cards__carousel');
        const paginationWrapper = carousel?.querySelector('.mt-resources-cards__pagination');
        paginationBtn.addEventListener('click', e => { 
            e.preventDefault();

            let invisibleCards = carousel.querySelectorAll('.swiper-slide.resource-hidden');
            for (let i = 0; i < Number(carousel.dataset.cardsPerPage); i++) {
                invisibleCards[i]?.classList.remove('resource-hidden');
            }
            invisibleCards = carousel.querySelectorAll('.swiper-slide.resource-hidden');
            (invisibleCards.length === 0) && paginationWrapper?.classList.add('hidden');

            // Additional DL events
            app.dl.customClick('Load More', { location: _this.el.section.dataset.dlLocation })
        });
    });

    document.addEventListener('yt-api-loaded', () => {
        const urlParams = new URLSearchParams(window.location.search);
        const video = urlParams.get('video');
        if (!video) return;
        
        const card = _this.el.section.querySelector(`.mt-resource-card[data-handle="${video}"] .mt-resource-card__title`);
        if (card) {
            const videoId = window.app.lightbox.getYtVideoId(card.href);
            window.app.lightbox.open({ type: 'youtube', content: videoId });
            app.dl.customClick(card.dataset.title, { location: _this.el.section.dataset.dlLocation });
        }
    });

    _this.el.section.classList.add('initialized');
  }
}
window.app.resourcesList.init();